import {Component, HostListener} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {PassOnLogService} from '../../../services/pass-on-log.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'pass-on-log-list',
    templateUrl: './pass-on-log-list.component.html',
    styleUrls: ['./pass-on-log-list.component.scss']
})
export class PassOnLogListComponent {

    constructor(
        public urlService: UrlService,
        public passOnLogService: PassOnLogService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.passOnLogService.data.allPassOnLogs.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    showHint(e) {
        const $td = $(e.target).closest('.pass-on-log-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.pass-on-log-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.passOnLogService.data.allPassOnLogs.data.forEach(item => item.checked = false);
        if (checked && this.passOnLogService.selectedItemData) {
            this.passOnLogService.selectedItemData = null;
            this.passOnLogService.toggleDetailedView(null, false);
            selectedItem.checked = false;
        } else {
            selectedItem.checked = true;
            this.passOnLogService.selectedItemData = selectedItem;
            this.passOnLogService.toggleDetailedView(selectedItem, true);
        }
    }

    @HostListener('document:click', ['$event.target'])
    hideHint(targetElement: HTMLElement): void {
        if (!$(targetElement).closest('.pass-on-log-hint-td').length) {
            $('.pass-on-log-hint-td').removeClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-list/pass-on-log-list.component.ts